module.exports = __webpack_public_path__ + "static/media/oneHundredThousuand.000a680b.ogg";